<a routerLink="/">
  <img alt="" src="/assets/logo.svg" width="204" height="42">
</a>
